import { Link } from "react-router-dom";

import { BrandConstants } from "../constants/brand";
import { cn } from "../lib/cn";
import type { LogoProps, LogoSize } from "./logo.types";

const sizeClasses: Record<LogoSize, { mark: string; name: string; gap: string }> = {
  sm: { mark: "h-6 w-auto", name: "text-base", gap: "gap-2" },
  md: { mark: "h-8 w-auto", name: "text-xl", gap: "gap-3" },
  lg: { mark: "h-12 w-auto", name: "text-2xl", gap: "gap-3" },
  xl: { mark: "h-16 w-auto", name: "text-4xl", gap: "gap-4" },
};

export const Logo = ({
  variant = "horizontal",
  size = "md",
  disableLink,
  href,
  markSrc = "/brand/logo.svg",
}: LogoProps) => {
  const classes = sizeClasses[size];
  const content = (
    <>
      <img
        src={markSrc}
        alt=""
        aria-hidden="true"
        className={cn("shrink-0 object-contain", classes.mark)}
      />
      {variant !== "mark" && (
        <span className={cn("font-bold tracking-tight text-primary", classes.name)}>
          {BrandConstants.PRODUCT_NAME}
        </span>
      )}
    </>
  );
  const layoutClassName = cn(
    "inline-flex items-center transition-opacity hover:opacity-90 [&:hover_img]:scale-105 [&_img]:transition-transform",
    variant === "stacked" ? "flex-col text-center" : undefined,
    variant !== "mark" ? classes.gap : undefined
  );

  if (disableLink) {
    return <div className={layoutClassName}>{content}</div>;
  }

  if (href) {
    return (
      <a href={href} className={layoutClassName} aria-label={BrandConstants.PRODUCT_NAME}>
        {content}
      </a>
    );
  }

  // "/" redirects signed-in users to DEFAULT_PROTECTED_ROUTE_PATH (see App.jsx), so Logo needs no redirect logic of its own.
  return (
    <Link to="/" className={layoutClassName} aria-label={BrandConstants.PRODUCT_NAME}>
      {content}
    </Link>
  );
};
